import styled from 'styled-components';

interface MainContentProps {
  openSideBar: boolean;
}

export const MainContent = styled.div<MainContentProps>`
  &&.content {
    margin-left: ${props => (props.openSideBar ? '254px' : '71px')};
    background-color: #f5f5f5;
    height: 100%;
    padding: 32px 17px 32px;
    position: relative;
    width: 100%;
    transition: all 0.3s;
  }
`;

export const StyleVersionTag = {
  width: '100px',
  height: '25px',
  padding: '20px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: 'rgb(117, 117, 117)',
  bottom: '0px',
  right: '0px',
  color: 'rgb(255, 255, 255)',
  fontSize: '13px',
  borderRadius: '10px 10px 0px 0px',
};
